import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

/** Gebuchte Zeiteinträge + Summe eines Auftrags (eigener Query-Key, vom Auftrags-Detail entkoppelt). */
export function useOrderTime(orderId: number) {
  return useQuery({
    queryKey: ['orderTime', orderId],
    queryFn: () => api.listOrderTime(orderId),
    enabled: Number.isFinite(orderId),
  })
}
